import Philosophy from './Philosophy'

export default Philosophy
